import React from 'react';

const ArtistSelector = ({ 
  artistRole, 
  setArtistRole, 
  artistName, 
  setArtistName, 
  artists, 
  addArtist,
  disabled = false
}) => {
  return (
    <div className="row">
      <div className="col-md-5 px-1 mt-3">
        <div className="dash-form-group">
          <label>Artist Role</label>
          <select value={artistRole} onChange={(e) => setArtistRole(e.target.value)} className='dash-form-select'>
            <option>Featuring</option>
            <option>Primary Artist</option>
            <option>Producer</option>
            <option>Arranger</option>
            <option>Composer</option>
            <option>Composer & Lyricist</option>
            <option>Lyricist</option>
            <option>Engineer</option>
            <option>Mixer</option>
            <option>Vocal Producer</option>
            <option>Chorus</option>
            <option>Remixer</option>
          </select>
        </div>
      </div>
      <div className="col-md-5 px-1 mt-3">
        <div className="dash-form-group">
          <label>Artist Name</label>
          <div className="dropdown dash-form-dropdown">
            <button className="dropdown-toggle" type="button" data-bs-toggle="dropdown" aria-expanded="false">
              {artistName.name || 'Name'}
            </button>
            <ul className="dropdown-menu">
              <li data-bs-toggle="modal" data-bs-target="#artist1Modal">
                <i className="fi fi-rr-plus"></i>
                Create Artist
              </li>
              {artists.map((artist, i) => (
                <li key={i} onClick={() => setArtistName({name: artist.name, artistId: artist.id})}>
                  {artist.name}
                </li>
              ))}
            </ul>
          </div>
        </div>
      </div>
      <div className="col-md-2 px-1 mt-4">
        <div className="dash-form-group">
          <div style={{ marginBottom: '20px' }}></div>
          <button 
            className={`n-rounded-btn ${(artistName === 'Name' || disabled) && 'disabled'}`} 
            onClick={addArtist}
            disabled={artistName === 'Name' || disabled}
          >
            Add
          </button>
        </div>
      </div>
    </div>
  );
};

export default ArtistSelector; 